import React, { useEffect, useState } from 'react';
import { Container, Button, Modal, ModalHeader, ModalBody, ModalFooter, Table } from 'reactstrap';
import ConsommationServices from '../../services/ConsommationServices';
import RelaisServices from '../../services/RelaisServices';
import UserServices from '../../services/UserServices';

const initialConsommationState = {
    relais_id: 1,
    index_new: 0,
    index_old: 0,
    consommation: 0,
    amount: 0,
    volume: 0,
    slug: '',
    created_by: 1,
};

const Consommation = () => {
    const [consommations, setConsommations] = useState([]);
    const [relais, setRelais] = useState([]);
    const [users, setUsers] = useState([]);
    const [consommation, setConsommation] = useState(initialConsommationState);
    const [modal, setModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [consommationToDelete, setConsommationToDelete] = useState(null);
    const [message, setMessage] = useState("");
    const [alert, setAlert] = useState("");

    useEffect(() => {
        ConsommationServices.getConsommations().then(data => {
            setConsommations(data['data']);
        });
        RelaisServices.getRelais().then(data => {
            setRelais(data['data']);
        });
        UserServices.getUsers().then(data => {
            setUsers(data['data']);
        });
    }, []);





    const showRelaisName = (relaisId) => {
        const relay = relais.filter((r) => r.id === relaisId);
        let element;
        if (typeof relay[0] !== 'undefined') {
            element = relay[0];
        } else {
            element = {
                name: " "
            }
        }
        return element.name;
    };

    const showUserName = (userId) => {
        const user = users.filter((u) => u.id === userId);
        let element;
        if (typeof user[0] !== 'undefined') {
            element = user[0];
        } else {
            element = {
                first_name: " ",
                last_name: " "
            }
        }
        return `${element.first_name} ${element.last_name}`
    };

    const toggle = () => setModal(!modal);
    const toggleDeleteModal = () => setDeleteModal(!deleteModal);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setConsommation({ ...consommation, [name]: value });
        setAlert("");
    };

    const addConsommation = () => {
        if (
            consommation.relais_id.trim() === "" ||
            consommation.index_new.trim() === "" ||
            consommation.consommation.trim() === "" ||
            consommation.amount.trim() === "" ||
            consommation.volume.trim() === ""
        ) {
            setAlert("Veuillez remplir tous les champs obligatoires.");
            return false;
        }
        let consommationToAdd = {
            relais_id: consommation.relais_id,
            index_new: consommation.index_new,
            consommation: consommation.consommation,
            amount: consommation.amount,
            volume: consommation.volume,
            created_by: parseInt(localStorage.getItem('created_by'))
        };
        ConsommationServices
            .addConsommation(consommationToAdd)
            .then(data => {
                console.log(data);
                setAlert("");
                if (data['success'] === true) {
                    setConsommations([...consommations, consommationToAdd]);
                    setConsommation(initialConsommationState);
                    toggle();
                    setMessage("Consommation ajoutée avec succès !");
                } else if (data['success'] === false) {
                    setMessage("");
                    setAlert(data['message']);
                }
            });
    };

    const deleteConsommation = (consommationToDelete) => {
        ConsommationServices
            .deleteConsommation(consommationToDelete)
            .then(data => {
                console.log(data);
                setAlert("");
                if (data['success'] === true) {
                    setConsommations(consommations.filter((consommation) => consommation.id !== consommationToDelete.id));
                    setConsommationToDelete(null);
                    toggleDeleteModal();
                    setMessage("Consommation supprimée avec succès !");
                } else if (data['success'] === false) {
                    setMessage("");
                    setAlert(data['message']);
                }
            });
    };

    const editConsommation = (consommation) => {
        setConsommation(consommation);
        toggle();
    };

    const updateConsommation = () => {
        if (
            consommation.relais_id.trim() === "" ||
            consommation.index_new.trim() === "" ||
            consommation.index_old.trim() === "" ||
            consommation.consommation.trim() === "" ||
            consommation.amount.trim() === "" ||
            consommation.volume.trim() === ""
        ) {
            setAlert("Veuillez remplir tous les champs obligatoires.");
            return false;
        }
        
        ConsommationServices
            .updateConsommation(consommation)
            .then(data => {
                console.log(data);
                setAlert("");
                if (data['success'] === true) {
                    setConsommations(consommations.map((c) => (c.id === consommation.id ? consommation : c)));
                    setConsommation(initialConsommationState);
                    toggle();
                    setMessage("Consommation modifiée avec succès !");
                } else if (data['success'] === false) {
                    setMessage("");
                    setAlert(data['message']);
                }
            });
    };

    const confirmDeleteConsommation = (consommation) => {
        setConsommationToDelete(consommation);
        toggleDeleteModal();
    };

    return (
        <Container>
            <h1 className='mb-5'>Liste des consommations</h1>

            {message && <div className="alert alert-success mt-1">{message}</div>}
            {alert && <div className="alert alert-danger mt-1">{alert}</div>}
            <Button color='primary' onClick={toggle}>
                Ajouter une consommation
            </Button>
            <Table>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Relais</th>
                        <th>Nouveau</th>
                        <th>Ancien</th>
                        <th>Consommation</th>
                        <th>Montant</th>
                        <th>Volume</th>
                        <th>Créé par</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {consommations.map((consommation) => (
                        <tr key={consommation.id}>
                            <td>{consommation.id}</td>
                            <td>{showRelaisName(consommation.relais_id)}</td>
                            <td>{consommation.index_new}</td>
                            <td>{consommation.index_old}</td>
                            <td>{consommation.consommation}</td>
                            <td>{consommation.amount}</td>
                            <td>{consommation.volume}</td>
                            <td>{showUserName(consommation.created_by)}</td>
                            <td>
                                <Button color='info' onClick={() => editConsommation(consommation)}>
                                    Modifier
                                </Button>{' '}
                                <Button color='danger' onClick={() => confirmDeleteConsommation(consommation)}>
                                    Supprimer
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>{consommation.id ? 'Modifier la consommation' : 'Ajouter une consommation'}</ModalHeader>
                <ModalBody>
                    <div className='form-group'>
                        <label htmlFor='relais_id'>Relais</label>
                        <select
                            className='form-control form-select'
                            id='relais_id'
                            name='relais_id'
                            value={consommation.relais_id}
                            onChange={handleInputChange}
                            required={true}
                        >
                            {relais.map((relai) => (
                                <option key={relai.id} value={relai.id}>
                                    {relai.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className='form-group'>
                        <label htmlFor='index_new'>Nouveau</label>
                        <input type='number'
                            className='form-control'
                            id='index_new' name='index_new'
                            value={consommation.index_new}
                            onChange={handleInputChange}
                            required={true} />
                    </div>
                    <div className='form-group'>
                        <label htmlFor='index_old'>Ancien</label>
                        <input type='number'
                            className='form-control'
                            id='index_old'
                            name='index_old'
                            disabled={consommation.id ? false : true}
                            value={consommation.index_old}
                            onChange={handleInputChange} />
                    </div>
                    <div className='form-group'>
                        <label htmlFor='consommation'>Consommation</label>
                        <input type='number'
                            className='form-control'
                            id='consommation'
                            name='consommation'
                            value={consommation.consommation}
                            onChange={handleInputChange}
                            required={true} />
                    </div>
                    <div className='form-group'>
                        <label htmlFor='amount'>Montant</label>
                        <input type='number'
                            className='form-control'
                            id='amount'
                            name='amount'
                            value={consommation.amount}
                            onChange={handleInputChange}
                            required={true} />
                    </div>
                    <div className='form-group'>
                        <label htmlFor='volume'>Volume</label>
                        <input type='number'
                            className='form-control'
                            id='volume'
                            name='volume'
                            value={consommation.volume}
                            onChange={handleInputChange}
                            required={true} />
                    </div>
                </ModalBody>
                <ModalFooter>
                    {consommation.id ? (
                        <Button color='primary' onClick={updateConsommation}>
                            Modifier
                        </Button>
                    ) : (
                        <Button color='primary' onClick={addConsommation}>
                            Ajouter
                        </Button>
                    )}{' '}
                    <Button color='secondary' onClick={toggle}>
                        Annuler
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={deleteModal} toggle={toggleDeleteModal}>
                <ModalHeader toggle={toggleDeleteModal}>Confirmation de suppression</ModalHeader>
                <ModalBody>
                    Êtes-vous sûr de vouloir supprimer la consommation n°{consommationToDelete?.id} ?
                </ModalBody>
                <ModalFooter>
                    <Button color='danger' onClick={() => deleteConsommation(consommationToDelete)}>
                        Supprimer
                    </Button>{' '}
                    <Button color='secondary' onClick={toggleDeleteModal}>
                        Annuler
                    </Button>
                </ModalFooter>
            </Modal>
        </Container>
    );
};

export default Consommation;
